const RESERVED_WINDOWS_FILE_NAMES = /^(CON|PRN|AUX|NUL|COM[1-9]|LPT[1-9])(?:\..*)?$/i;
const INVALID_WINDOWS_FILE_NAME_CHARACTERS = /[\\/:*?"<>|]/;
const PDF_EXTENSION = '.pdf';
const MAX_WINDOWS_FILE_NAME_LENGTH = 255;

function hasControlCharacter(fileName) {
  return Array.from(fileName).some((character) => character.charCodeAt(0) <= 31);
}

export function getPdfDisplayFileName(fileName) {
  if (typeof fileName !== 'string') {
    return '';
  }

  return fileName.replace(/\.pdf$/i, '');
}

export function getPdfDownloadFileName(fileName) {
  const displayFileName = getPdfDisplayFileName(fileName);
  return `${displayFileName}${PDF_EXTENSION}`;
}

export function isValidWindowsFileName(fileName) {
  if (typeof fileName !== 'string') {
    return false;
  }

  if (fileName.trim() === '') {
    return false;
  }

  if (/^[. ]+$/.test(fileName)) {
    return false;
  }

  if (INVALID_WINDOWS_FILE_NAME_CHARACTERS.test(fileName) || hasControlCharacter(fileName)) {
    return false;
  }

  if (/[. ]$/.test(fileName)) {
    return false;
  }

  if (RESERVED_WINDOWS_FILE_NAMES.test(fileName)) {
    return false;
  }

  return true;
}

export function isValidWindowsPdfFileName(fileName) {
  const displayFileName = getPdfDisplayFileName(fileName);

  if (!isValidWindowsFileName(displayFileName)) {
    return false;
  }

  return getPdfDownloadFileName(displayFileName).length <= MAX_WINDOWS_FILE_NAME_LENGTH;
}
